import { TFunction } from 'i18next';
import { GridEnrichedColDef, GridRenderCellParams } from '@mui/x-data-grid-pro';
import { StatusCell } from './component';
import Util from '../../../../../misc/util';
import { ReceiptStatus } from '../../../../../viewModels/receipts';
import { ReceiptsRowViewModel } from '../../row/viewModel';
import { ReceiptsCellViewModel } from '../viewModel';

export class StatusCellViewModel extends ReceiptsCellViewModel {
  constructor(row: ReceiptsRowViewModel) {
    super(row);
  }

  get t() {
    return this.row.translate;
  }

  get label() {
    return this.receipt.status?.name;
  }

  get cellValue() {
    return this.receipt.status.value;
  }

  get title() {
    return this.t('receipts:STATUS', { context: this.receipt.status?.value });
  }

  get value() {
    return this.label;
  }

  static buildColDef(t: TFunction): GridEnrichedColDef {
    const valueOptions = Util.getKeys(ReceiptStatus, ['DeletionSubmitted']).map((key) => ({
      label: t(`receipts:STATUS_${ReceiptStatus[key]}`),
      value: ReceiptStatus[key]
    }));
    return {
      field: 'status',
      headerName: t('employee:STATUS'),
      description: t('employee:STATUS_COLUMN_INFO'),
      minWidth: 60,
      type: 'singleSelect',
      valueOptions: valueOptions,
      renderCell: (params: GridRenderCellParams<StatusCellViewModel>) => <StatusCell {...params} />
    };
  }
}
